import { useContext } from 'react'

import { BundleContext, BundleContextState } from '../context/BundleProvider'


const useBundle = () => {
    const bundle = useContext(BundleContext)

    if (!bundle) {
        /**
         * Failed to load/validate fetched bundle. This should never happen
         */
        throw new Error('Bundle is not loaded')
    }

    return bundle as BundleContextState
}

export {
    useBundle,
}
